<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>客单价表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-items: center">
      <el-date-picker
        v-model="reportRequestBody.selectDay"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectReportDataDay"
        value-format="yyyy-MM-dd"
        v-if="reportTabName == 'day' || reportTabName == 'area'"
      >
      </el-date-picker>
      <el-date-picker
        v-model="reportRequestBody.selectMonth"
        type="monthrange"
        range-separator="至"
        size="mini"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        @change="selectReportDataMonth"
        value-format="yyyy-MM"
        v-if="reportTabName == 'month'"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
                 style="width: 200px" size="mini" @change="getArea">
        <el-option
          v-for="item in area"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectOrgId" v-if="orgLevel < 3 " clearable value filterable placeholder="请选择门店"
                 style="width: 200px" size="mini" @change="getShop">
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>
      <el-select v-model="reportRequestBody.userId" clearable value filterable placeholder="请选择员工"
                 style="width: 200px" size="mini" @change="getUser">
        <el-option
          v-for="user in users"
          :key="user.id"
          :label="user.userName"
          :value="user.id">
        </el-option>
      </el-select>
      <el-select v-model="selectService" clearable value filterable placeholder="请选择项目"
                 style="width: 200px" size="mini" @change="getService">
        <el-option
          v-for="org in services"
          :key="org.label"
          :label="org.label"
          :value="org.value">
        </el-option>
      </el-select>

      <el-button size="mini" style="margin-left: 5px;" @click="loadKpiData(reportTabName)">查询</el-button>
    </div>
    <el-tabs v-model="reportTabName" @tab-click="reportTabNameClick" type="border-card" style="height: 650px">
      <el-tab-pane label="日" name="day"></el-tab-pane>
      <el-tab-pane label="月" name="month"></el-tab-pane>
      <el-tab-pane label="年" name="year"></el-tab-pane>
      <el-tab-pane label="区域" name="area" v-if="orgLevel<3"></el-tab-pane>
      <div>
        <el-table height="550px" :data="kpiDataList" fit border stripe="stripe"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  ref="tableName"

                  show-summary>
          <el-table-column
            align="center"
            prop="reportDate"
            label="日期"
            width="150"
            v-if="reportTabName === 'day'"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="reportMonth"
            label="月份"
            width="150"
            v-if="reportTabName === 'month'"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="reportYear"
            label="年份"
            width="150"
            v-if="reportTabName === 'year'"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="areaName"
            label="区域"
            width="150"
            v-if="reportTabName === 'area' && orgLevel == 1"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="shopName"
            label="门店"
            width="150"
            v-if="reportTabName === 'area' && orgLevel == 2"
          >
          </el-table-column>
<!--          <el-table-column-->
<!--            align="center"-->
<!--            prop="shopName"-->
<!--            label="机构名称"-->
<!--            width="150"-->
<!--          >-->
<!--          </el-table-column>-->
          <el-table-column
            align="center"
            prop="consumptionName"
            label="服务项目"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="money"
            label="实收金额"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="peoples"
            label="消费人数"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="客单价"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.kdj.toFixed(2)}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data(){
    return{
      userId:'',
      orgId:'',
      orgLevel:'',
      authorities:'',
      performanceDate:'',
      tableTitle:[],
      kpiDataList:[],
      area:[],
      shop:[],
      users:[],
      selectAreaId:'',
      selectOrgId:'',
      selectService:'',
      selectUserId:'',
      reportTabName:'day',
      reportRequestBody:{
        selectDay:'',
        startDate:'',
        endDate:'',
        selectMonth:'',
        startMonth:'',
        endMonth:'',
        oneLevelHeader:'',
        shopId:0,
        areaId:0,
        orgId:'',
        userId:'',
        orgLevel:'',
        userName:'',
        consumptionName:''
      },
      towLevelDataDialogVisible:false,
      towLevelTitle:[],
      towLevelDataList:[],
      tabName:'day',
      dayTip:false,
      monthTip:false,
      services:[
        {label:'足科', value:'足科'},
        {label:'团购', value:'团购'},
        {label:'矫正', value:'矫正'},
        {label:'肉刺修复', value:'肉刺修复'},
        {label:'刺痛茧修复', value:'刺痛茧修复'},
        {label:'异形甲修复', value:'异形甲修复'}
      ]
    }
  },
  methods:{
    reportTabNameClick(tab, event){
      this.reportTabName = tab.name;
      this.reportRequestBody.selectDay='';
      this.reportRequestBody.selectMonth='';
      this.reportRequestBody.shopId='';
      this.reportRequestBody.orgId='';
      this.reportRequestBody.userId='';
      this.selectAreaId='';
      this.selectOrgId='';
      this.kpiDataList = [];
      this.loadKpiData(tab.name);
    },
    async getArea(data){
      if (data !== ''){
        this.reportRequestBody.areaId = data;
        const {data:res} = await this.$http.get(`/orgs/area/orgId/${data}`);
        this.shop = res.data;
      } else {
        this.reportRequestBody.areaId = 0;
      }
    },
    async getShop(data){
      if (data !== ''){
        this.reportRequestBody.shopId = data;
        const {data:res} = await this.$http.get(`/org/users/${data}`);
        this.users = res.data;
      } else {
        this.reportRequestBody.shopId = 0;
        this.users = [];
      }
    },
    getService(data){
      if (data !== ''){
        this.reportRequestBody.consumptionName = data;
      } else {
        this.reportRequestBody.consumptionName = '';
      }
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
    getCurrentMonth () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      if (month < 10) month = '0' + month
      return date.getFullYear() + '-' + month;
    },
    getCurrentMonthFirst () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthLast () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = new Date(year, month, 0)
      return year + '-' + month + '-' + day.getDate()
    },
    loadKpiData(reportTabName){
      this.reportRequestBody.startDate='';
      this.reportRequestBody.endDate='';
      this.reportRequestBody.startMonth='';
      this.reportRequestBody.endMonth='';

      if (this.reportRequestBody.consumptionName == ''){
        this.$message.warning('请选择要查询的项目')
        return;
      }
      if (reportTabName ==='day'){
        this.loadKpiDataByDay();
      }
      if (reportTabName ==='month'){
        this.loadKpiDataByMonth();
      }
      if (reportTabName ==='year'){
        this.loadKpiDataByYear();
      }
      if (reportTabName ==='area'){
        this.loadKpiDataByArea();
      }

      this.$nextTick(() => {
        this.$refs.tableName.doLayout();
        // el-table添加ref="tableName"
      });
    },
    async loadKpiDataByDay(){
      this.reportRequestBody.startDate = this.getCurrentMonthFirst();
      this.reportRequestBody.endDate = this.getCurrentMonthLast();
      if (this.reportRequestBody.selectDay !== '' && this.reportRequestBody.selectDay != null){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }

      if (this.orgLevel == 2){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }

      const {data:res} = await this.$http.post(`/report/kdj/day`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    async loadKpiDataByMonth(){
      if (this.reportRequestBody.selectMonth !== '' && this.reportRequestBody.selectMonth != null){
        this.reportRequestBody.startMonth = this.reportRequestBody.selectMonth[0];
        this.reportRequestBody.endMonth = this.reportRequestBody.selectMonth[1];
      }
      if (this.orgLevel == 2){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      const {data:res} = await this.$http.post(`/report/kdj/month`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    async loadKpiDataByArea(){
      this.reportRequestBody.startDate = this.getCurrentMonthFirst();
      this.reportRequestBody.endDate = this.getCurrentMonthLast();
      if (this.reportRequestBody.selectDay !== ''){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }
      if (this.orgLevel == 2){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      const {data:res} = await this.$http.post(`/report/kdj/area`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },
    async loadKpiDataByYear(){
      if (this.orgLevel == 2){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        // this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      // await this.loadTableTitle();
      const {data:res} = await this.$http.post(`/report/kdj/year`, this.reportRequestBody)
      this.kpiDataList = res.data;
    },

    selectReportDataDay(data){
      if (data == null){
        this.reportRequestBody.selectDay = '';
      } else {
        this.reportRequestBody.selectDay = data;
      }
    },
    selectReportDataMonth(data){
      if (data == null){
        this.reportRequestBody.selectMonth = '';
      } else {
        this.reportRequestBody.selectMonth = data;
      }
    },
    async loadShop(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
    exportKpiData(reportTabName){
      this.reportRequestBody.startDate='';
      this.reportRequestBody.endDate='';
      this.reportRequestBody.startMonth='';
      this.reportRequestBody.endMonth='';

      if (reportTabName ==='day'){
        this.exportKpiDataByDay();
      }
      if (reportTabName ==='month'){
        this.loadKpiDataByMonth();
      }
      if (reportTabName ==='year'){
        this.loadKpiDataByYear();
      }
      if (reportTabName ==='area'){
        this.loadKpiDataByArea();
      }
    },
    getUser(data){
      if (data !== ''){
        // this.reportRequestBody.userId = data;
        this.selectUserId = data;
      } else {
        // this.reportRequestBody.userId = '';
        this.selectUserId = '';
      }
    },
    async exportKpiDataByDay(){
      this.reportRequestBody.startDate = this.getCurrentMonthFirst();
      this.reportRequestBody.endDate = this.getCurrentMonthLast();
      if (this.reportRequestBody.selectDay !== '' && this.reportRequestBody.selectDay != null){
        this.reportRequestBody.startDate = this.reportRequestBody.selectDay[0];
        this.reportRequestBody.endDate = this.reportRequestBody.selectDay[1];
      }
      // this.$http.post('/export/performance/data/oneLevel/day', this.reportRequestBody, { responseType: 'blob' })
      //   .then((resp) => {
      //     if (!resp) {
      //       console.log('下载数据返回空')
      //       return
      //     }
      //     const link = document.createElement('a');
      //     let blob = new Blob([resp.data], {type: 'application/vnd.ms-excel'});
      //     link.style.display = 'none';
      //     link.href = URL.createObjectURL(blob);
      //     link.setAttribute('download', '课程列表信息' + '.xls');
      //     document.body.appendChild(link);
      //     link.click();
      //     document.body.removeChild(link);
      //   })
    },
  },

  created() {
    this.dayTip = true;
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      // this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.areaId = this.orgId;
      this.loadShop();
    }
    if (this.orgLevel == 3){
      // this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.shopId = this.orgId;
    }
    this.loadKpiData('day');
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-input__inner{
  height: 30px;
  line-height: 30px;
}
/deep/.el-input__icon,.el-icon-date{
  line-height: 35px;
}
/deep/.el-input__icon, .el-range__icon, .el-icon-date{
  line-height: 25px;
}
/deep/.el-range-separator{
  line-height: 23px;
}
.dialog-footer{
  display: flex;
  margin: 30px 20px 20px 0;
  justify-content: center;
  width: 100%;
}
/deep/.el-button--text{
  color: #ecf5ff;
}
.el-table {
  overflow: visible !important;
  //overflow: auto !important;
}

/deep/.el-tabs--card>.el-tabs__header {
  border-bottom: 1px solid #E4E7ED;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 10px;
}
/deep/.el-tabs__content {
  overflow: hidden;
  position: relative;
  height: 600px;
}
/deep/.el-table__body-wrapper .is-scrolling-left{
  height: 483px;
}
/deep/.el-tabs__content.el-table__fixed{
  height: 539px;
}
/deep/ .el-table__fixed{
  height: 100% !important;
}
/deep/ .el-table__fixed-right,.el-table__fixed-body-wrapper{
  height: 100% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ReportKdj.vue